/* tslint:disable:variable-name */
/* eslint-disable @typescript-eslint/camelcase */

export const white = '#ffffff';
export const background_800 = '#1d2129';
export const background_500 = '#4a4d54';
export const background_300 = '#777a7f';
export const background_200 = '#a5a6a9';
export const background_150 = '#d2d3d4';
export const background_100 = '#dddedf';
export const background_50 = '#e8e8e9';
export const background_20 = '#f3f4f4';
export const blue_500 = '#000066';
export const blue_400 = '#000991';
export const blue_300 = '#000cc0';
export const blue_200 = '#89a0f1';
export const blue_100 = '#cfdaff';
export const blue_50 = '#eef4ff';
export const red_500 = '#6f0000';
export const red_400 = '#af0000';
export const red_300 = '#cc0000';
export const red_200 = '#e26b6b';
export const red_100 = '#ffbbbb';
export const red_50 = '#ffe2e2';
export const green_500 = '#0b3508';
export const green_400 = '#084f03';
export const green_300 = '#087a00';
export const green_200 = '#1fa716';
export const green_100 = '#a3df9f';
export const green_50 = '#e6fce5';
export const orange_500 = '#953d00';
export const orange_400 = '#cc5300';
export const orange_300 = '#ff6800';
export const orange_200 = '#ff8938';
export const orange_100 = '#ffb583';
export const orange_50 = '#feead3';
export const text_800 = '#2a2a2e';
export const text_500 = '#737373';
export const text_300 = '#b1b1b3';
export const text_100 = '#f9f9fa';
export const text_white = '#ffffff';
export const alpha_black_80 = 'rgba(0, 0, 0, 0.8)';
export const alpha_black_60 = 'rgba(0, 0, 0, 0.6)';
export const alpha_black_40 = 'rgba(0, 0, 0, 0.4)';
export const alpha_black_15 = 'rgba(0, 0, 0, 0.15)';
export const alpha_white_80 = 'rgba(255, 255, 255, 0.8)';
export const alpha_white_60 = 'rgba(255, 255, 255, 0.6)';
export const alpha_white_40 = 'rgba(255, 255, 255, 0.4)';
export const alpha_white_30 = 'rgba(255, 255, 255, 0.3)';
export const alpha_white_20 = 'rgba(255, 255, 255, 0.2)';
